import { TextEditableField } from "components/fields/EditableField";
import React from "react";
import { rankChoicesGetter } from "utils/getter";

export const RankField = ({ rankPriorities, ...props }) => {
	let title = "";
	let rankStyle = {};
	if (
		rankPriorities &&
		props.record &&
		Number.isInteger(props.record.rank) &&
		Number.isInteger(props.record.rank_auto)
	) {
		title = "Rank auto group - " + props.record.rank_auto;
		rankStyle = {
			backgroundColor:
				rankPriorities[props.record.rank_auto] && rankPriorities[props.record.rank_auto].color,
			textAlign: "center",
			border: "1px solid #000000",
			borderRadius: "100%",
		};
	}
	// const choices = props.record.rank ?  [{id: false, name: "NO (" +  props.record.rank + ")"}, {id: true, name: "YES (M)"}] :
	// 									 [{id: false, name: "NO ()"}, {id: true, name: "YES (M)"}];
	const rankChoices = rankChoicesGetter(props.record);

	return <TextEditableField title={title} style={rankStyle} choices={rankChoices} {...props} />;
};
